import React from "react"
import qs from "qs"

class SnsButtons extends React.Component {
  render() {
    const { title, siteUrl, slug, twitter, from } = this.props

    const pageUrl = `${siteUrl}${slug}`
    const espacedTitle = title
    const username = twitter
    const isArchive = from === 'archive'

    return (
      <div style={{textAlign: `center`, verticalAlign: `middle`, display: `${isArchive ? "inline-block" : "block"}` }}>
        <ul style={{ listStyle: `none`, padding: 0, margin: 0, display: `inline-block` }}>
          <li style={{ display: `inline`, margin: `0 .2em` }}><a href={`https://www.facebook.com/sharer/sharer.php?${qs.stringify({ u: pageUrl, t: espacedTitle })}`} title="Share on Facebook" target="_blank" rel="noopener noreferrer nofollow"><img alt="Share on Facebook" src="/Facebook.png" /></a></li>
          <li style={{ display: `inline`, margin: `0 .2em` }}><a href={`https://twitter.com/intent/tweet?${qs.stringify({ source: pageUrl, text: `${espacedTitle}: ${pageUrl}`, via: username })}`} target="_blank" rel="noopener noreferrer nofollow" title="Tweet"><img alt="Tweet" src="/Twitter.png" /></a></li>
          <li style={{ display: `inline`, margin: `0 .2em` }}><a href={`https://getpocket.com/save?${qs.stringify({ url: pageUrl, title: espacedTitle })}`} target="_blank" rel="noopener noreferrer nofollow" title="Add to Pocket"><img alt="Add to Pocket" src="/Pocket.png" /></a></li>
        </ul>
      </div>
    )
  }
}

export default SnsButtons
